import initialState from 'redux/initialState';
import types from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { Partner } from 'types';
import { partnerSharesTypes } from '../types/partnerSharesTypes';

type PartnerAction = {
  type: string;
  partners?: Partner[];
  partner?: Partner;
  partnerId?: string;
  partnerShares?: Record<string, number>;
  sharesType?: (typeof partnerSharesTypes)[keyof typeof partnerSharesTypes];
};
const resetStateSociety = () => initialState.partners;

const createPartner = (partners: Partner[], action: PartnerAction) => [
  ...partners,
  action.partner,
];

const getPartners = (action: PartnerAction) => action.partners;

const updatePartner = (partners: Partner[], action: PartnerAction) =>
  partners?.map((partner: Partner) =>
    partner._id === action.partner?._id ? action.partner : partner
  );

const updatePartnerShares = (partners: Partner[], action: PartnerAction) =>
  partners?.map((partner: Partner) => {
    let { sharesCount } = partner;
    const newShares = action.partnerShares?.[partner._id];

    switch (action.sharesType) {
      case partnerSharesTypes.ACTUAL: {
        const actualShares = partner?.sharesCount?.actual || 0;
        const newActualShares = (newShares || 0) + actualShares;

        sharesCount = {
          ...partner.sharesCount,
          actual: newActualShares,
        };

        break;
      }

      case partnerSharesTypes.FUTURE: {
        const futureShares = partner?.sharesCount?.future || 0;
        const newFutureShares = (newShares || 0) + futureShares;

        sharesCount = {
          ...partner.sharesCount,
          future: newFutureShares,
        };

        break;
      }

      case partnerSharesTypes.DRAFTS: {
        const draftsShares = partner?.sharesCount?.drafts || 0;
        const newDraftsShares = (newShares || 0) + draftsShares;

        sharesCount = {
          ...partner.sharesCount,
          drafts: newDraftsShares,
        };

        break;
      }

      default:
        return partner.sharesCount;
    }

    return {
      ...partner,
      sharesCount,
    };
  });

const deletePartner = (partners: Partner[], action: PartnerAction) =>
  partners?.filter((partner: Partner) => partner._id !== action.partnerId);

export default function reducer(partners = initialState.partners, action: any) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case types.CREATE_PARTNER:
      return createPartner(partners, action);

    case types.GET_PARTNERS:
      return getPartners(action);

    case types.UPDATE_PARTNER:
      return updatePartner(partners, action);

    case types.UPDATE_PARTNER_SHARES:
      return updatePartnerShares(partners, action);

    case types.DELETE_PARTNER:
      return deletePartner(partners, action);

    default:
      return partners;
  }
}
